import changePasswordSVG from '../img/change-password.svg';
import editSVG from '../img/edit.svg';

export const items = [
  {
    svg: editSVG,
    title: 'editAccount',
    link: '/user/edit',
  },
  {
    svg: changePasswordSVG,
    title: 'changePassword',
    link: '/user/change-password',
  },
];
